import { render, staticRenderFns } from "./ViewFixedPayments.vue?vue&type=template&id=b0371be2&"
import script from "./ViewFixedPayments.vue?vue&type=script&lang=js&"
export * from "./ViewFixedPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewFixedPayments.vue"
export default component.exports